import { FavoritedIcon, FavoriteIcon } from '@blocksuite/icons/rc';
import { cssVarV2 } from '@streamlain/theme/v2';
import type { SVGProps } from 'react';

export const IsFavoriteIcon = ({
  favorite,
  style,
  ...props
}: { favorite?: boolean } & SVGProps<SVGSVGElement>) => {
  return favorite ? (
    <FavoritedIcon
      style={{ color: cssVarV2('brand/primary'), ...style }}
      {...props}
    />
  ) : (
    <FavoriteIcon style={style} {...props} />
  );
};
